import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Lock, Sparkles, Wallet, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRICE_LABEL, PRIMARY_CTA, packageIncludes } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
export function PricingSection() {
  const firstBonusIndex = packageIncludes.findIndex(item => item.kind === 'bonus');
  const firstExtraIndex = packageIncludes.findIndex(item => item.kind === 'extra');
  return <section id="pricing" className="py-20 px-4 bg-[#F3F5F7] relative" data-id="element-217" data-mp="1s7sl0hgc5sx2">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-218" data-mp="1x9rpxvrq4xw4">
        <div className="text-center mb-10" data-id="element-219" data-mp="227t5w7tush3d">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-3 text-[#16191E] uppercase" data-id="element-220" data-mp="226i42djyxjew">
            Your Complete <span className="text-[#E8590C]" data-id="element-221" data-mp="2wa1m6jhvx01">Welding Instructor Atlas</span> Package
          </h2>
          <p className="text-slate-700/80 text-sm md:text-base" data-id="element-222" data-mp="7ubpr5vs2mid">
            Everything You Need to Plan, Explain, Demonstrate &amp; Assess Your Students More Effectively
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-[#DDE2E8] border-2 border-[#16191E] rounded-3xl p-1 relative shadow-xl shadow-[#16191E]/10" data-id="element-223" data-mp="1hodbjz7qd7nk">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#F28A2E] text-[#0B0D10] font-bold px-5 py-1.5 rounded-full shadow uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap z-10" data-id="element-224" data-mp="20gfx9oz8be4o">
            <Sparkles size={14} data-id="element-225" data-mp="1rgj53ddmrx4v" /> Complete Package
          </div>
          <div className="bg-white rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-226" data-mp="1ri3xawch33zk">
            <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-md h-auto mx-auto mb-6" loading="lazy" data-id="element-227" data-mp="k3itb0ckch47" />

            <p className="text-sm font-bold tracking-widest text-[#B8480A] mb-3" data-id="element-228" data-mp="hib09ka3m3mx">YOU RECEIVE</p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-[#F3F5F7] border border-[#D5DAE0] rounded-xl p-4" data-id="element-229" data-mp="mgck47fcm6zg">
              <li className="text-xs font-bold tracking-widest text-[#B8480A]" data-id="element-230" data-mp="7ly8iry45zut">
                THE COMPLETE 6-IN-1 VISUAL WELDING TRAINING SYSTEM
              </li>
              {packageIncludes.map((item, itemIndex) => <React.Fragment key={item.label} data-id="element-231" data-mp="3hqjsurnojwl" data-mpi={itemIndex}>
                  {itemIndex === firstBonusIndex && <li className="pt-2 text-xs font-bold tracking-widest text-[#B8480A]" data-id="element-232" data-mp="3kz08dapbxlep">
                      PLUS 5 EXCLUSIVE BONUSES
                    </li>}
                  {itemIndex === firstExtraIndex && <li className="pt-2 border-t border-[#D5DAE0]" aria-hidden="true" data-id="element-233" data-mp="3bybt6co79f08" />}
                  <li className={`flex items-start gap-2 text-sm ${item.kind === 'extra' ? 'font-bold uppercase tracking-wide text-[#16191E]' : 'text-slate-700'}`} data-id="element-234" data-mp="3fylyro82y3ek">
                    {item.kind === 'bonus' ? <Gift size={16} className="text-[#E8590C] shrink-0 mt-0.5" data-id="element-235" data-mp="31cygk8lft8yc" /> : <Check size={16} className="text-[#E8590C] shrink-0 mt-0.5" data-id="element-236" data-mp="3g9fr4xlsyjju" />}
                    <span data-id="element-237" data-mp="3bbnvptly8faw">{item.label}</span>
                  </li>
                </React.Fragment>)}
            </ul>

            <div className="mb-6" data-id="element-238" data-mp="3p1rajzii16qb">
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-239" data-mp="3l0nx1jnxbms9">
                <span className="text-2xl md:text-3xl text-[#16191E] font-semibold" data-id="element-240" data-mp="3l31rbqas4uyr">YOUR PRICE:</span>
                <span className="text-4xl md:text-5xl font-extrabold tracking-tight text-[#E8590C]" data-id="element-241" data-mp="2sq4dyjnd9u7">
                  {PRICE_LABEL}
                </span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-242" data-mp="hvzy4lgbsjyp">
              {PRIMARY_CTA}
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate-500" data-id="element-243" data-mp="vq0niole0ume">
              <span className="flex items-center gap-1.5" data-id="element-244" data-mp="3v54g0lwp9k0a">
                <Lock size={12} className="text-[#E8590C]" data-id="element-245" data-mp="3v6p53w08waqr" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-246" data-mp="32whcgak6a91">
                <Zap size={12} className="text-[#E8590C]" data-id="element-247" data-mp="7yv7o9fg62c3" /> Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-248" data-mp="d011ybor9xnq">
                <Wallet size={12} className="text-[#E8590C]" data-id="element-249" data-mp="1jf21erczoxz2" /> One-Time Payment
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}